var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.searchable)?_c('input',{ref:"searchbox",staticClass:"map-searchbox",attrs:{"type":"text","placeholder":"Search..."}}):_vm._e(),_c('div',{ref:"map",staticClass:"uk-height-1-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }